import { Component, input, output } from '@angular/core';


@Component({
  standalone: true,
  imports: [],
  selector: 'sb-sign-in-button',
  template: `
    <button
      type="button"
      class="inline-flex items-center border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-150"
      [class]="getSizeClasses()"
      [disabled]="disabled() || loading()"
      (click)="onClick($event)"
    >
      @if (loading()) {
      <svg
        class="animate-spin text-white"
        [class]="getSpinnerSizeClasses()"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      {{ loadingText() }}
      } @else {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        [class]="getIconSizeClasses()"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0 3-3m0 0 3 3m-3-3h12.75"
        />
      </svg>
      {{ text() }}
      }
    </button>
  `,
})
export class SignInButtonComponent {
  // Button configuration
  text = input<string>('Sign In');
  loadingText = input<string>('Signing In...');
  size = input<'sm' | 'md' | 'lg'>('md');

  // State
  loading = input<boolean>(false);
  disabled = input<boolean>(false);

  // Output
  buttonClicked = output<void>();

  protected onClick(event: Event): void {
    event.stopPropagation();
    if (!this.disabled() && !this.loading()) {
      this.buttonClicked.emit();
    }
  }

  protected getSizeClasses(): string {
    const sizeMap = {
      sm: 'px-2.5 py-1.5 text-xs',
      md: 'px-4 py-2 text-sm',
      lg: 'px-6 py-3 text-base',
    };
    return sizeMap[this.size()];
  }

  protected getIconSizeClasses(): string {
    const sizeMap = {
      sm: '-ml-0.5 mr-1.5 h-3 w-3',
      md: '-ml-1 mr-2 h-4 w-4',
      lg: '-ml-1 mr-2.5 h-5 w-5',
    };
    return sizeMap[this.size()];
  }

  protected getSpinnerSizeClasses(): string {
    const sizeMap = {
      sm: '-ml-0.5 mr-1.5 h-3 w-3',
      md: '-ml-1 mr-2 h-4 w-4',
      lg: '-ml-1 mr-2.5 h-5 w-5',
    };
    return sizeMap[this.size()];
  }
}
